import React from "react";
import AllGrocery from "./ProductsList/AllGrocery";
import AllFashion from "./ProductsList/AllFashion";

export default function ProductPage(props) {
  var value = props.location.values;
  console.log("val", value);

  const valuepassed = () => {
    if (value === "Grocery") {
      return <AllGrocery />;
    } else if (value === "Fashion") {
      return <AllFashion />;
    } else {
      return <h2>Unknown</h2>;
    }
  };

  return (
    <div className="productpage">
      <div className="container-fluid">
        <h3>{"Your are viewing " + value}</h3>
        {valuepassed()}
        {/* {value === "Grocery" ? <AllGrocery /> : <Fashion />} */}
      </div>
    </div>
  );
}
